var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.27 8.48a.755.755 0 0 1-.46-.34L4.25 5.58c-.38-.62-.5-1.36-.32-2.08.17-.71.61-1.32 1.24-1.7.62-.38 1.36-.5 2.08-.32.72.17 1.32.61 1.7 1.24l1.56 2.56c.22.35.1.81-.25 1.03L6.84 8.39c-.12.07-.25.11-.39.11-.06 0-.12-.01-.18-.02zm-.32-5.4a1.256 1.256 0 0 0-.42 1.71L6.7 6.71l2.14-1.3-1.17-1.92c-.17-.28-.45-.48-.77-.56-.11-.02-.21-.03-.31-.03-.23 0-.45.06-.64.18zM10.53 22.48c-.88-.26-1.59-.86-2-1.71l-2.05-4.18a4.729 4.729 0 0 1 1.79-6.15l3.16-1.92a4.724 4.724 0 0 1 6.29 1.23l2.77 3.74c.56.76.77 1.67.6 2.56-.17.89-.71 1.66-1.52 2.15l-6.43 3.91c-.54.33-1.13.5-1.72.5-.3 0-.6-.04-.89-.13zM12.2 9.8l-3.16 1.92a3.238 3.238 0 0 0-1.23 4.21l2.05 4.18c.23.46.61.79 1.08.93.47.14.97.06 1.4-.2l6.43-3.91c.44-.27.73-.68.83-1.16.09-.48-.02-.97-.33-1.38l-2.77-3.74a3.19 3.19 0 0 0-2.6-1.33c-.58 0-1.16.16-1.7.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.41a.755.755 0 0 1-.46-.34L4.96 8.65a.75.75 0 0 1 .25-1.03l5.12-3.12c.35-.21.82-.1 1.03.25l2.08 3.42c.1.17.14.37.09.57-.05.19-.17.36-.34.46l-5.12 3.12c-.12.08-.26.11-.39.11-.06 0-.12-.01-.18-.02zm.43-1.75 3.84-2.34-1.3-2.14-3.84 2.34 1.3 2.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.32 19.91-1.65-2.71a.75.75 0 0 1 .25-1.03c.35-.21.82-.1 1.03.25l1.65 2.71a.75.75 0 0 1-1.28.78zM12.76 21.47l-1.65-2.71a.75.75 0 0 1 .25-1.03c.35-.21.82-.1 1.03.25l1.65 2.71a.75.75 0 0 1-1.28.78zM17.88 18.35l-1.65-2.71a.75.75 0 0 1 .25-1.03c.35-.21.82-.1 1.03.25l1.65 2.71a.75.75 0 0 1-1.28.78z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBroom);
export default __webpack_public_path__ + "static/media/vuesax-outline-broom.d6d4a3ae921f077a9cbd47fde43263fc.svg";
export { ForwardRef as ReactComponent };